import { ProductVariant } from '../models';

// we sort variants in following order
// 1. initially selected variant
// 2. regular available variants
// 3. unavailable variants

// result < 0, a is first
// result > 0, b is first
// result = 0, order doesn't matter
export const compareVariants = (
  initialVariantId: string | null,
  availableVariantsId: string[],
) => (a: ProductVariant, b: ProductVariant) => {
  if (a.productId === initialVariantId) {
    return -1;
  }
  if (b.productId === initialVariantId) {
    return 1;
  }

  const isFirstAvailable = availableVariantsId.includes(a.productId);
  const isSecondAvailable = availableVariantsId.includes(b.productId);
  // a is available, b is not, so a should go earlier
  if (isFirstAvailable && !isSecondAvailable) {
    return -1;
  }
  // a is not available, b is, so a should go later
  if (!isFirstAvailable && isSecondAvailable) {
    return 1;
  }
  // if both available, or not available, the order doesn't matter
  return 0;
};
